/* After an update, the old version's code files are gone. A page that still runs the old version and asks
   for one of them gets nothing back; instead of a blank page, load the new version (once; if it still fails,
   the page's error card takes over). */
const KEY = 'pinnr:freshAt'

export function reloadForUpdate(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0)
    if (Date.now() - last < 15000) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch { /* storage off: still try once */ }
  location.reload()
  return true
}

/* A page's code, loaded on demand, that recovers from an update instead of breaking. */
export function loadPage<T>(load: () => Promise<T>): () => Promise<T> {
  return () => load().catch((e) => {
    if (reloadForUpdate()) return new Promise<T>(() => {}) // the reload is on its way
    throw e
  })
}

window.addEventListener('vite:preloadError', (e) => {
  if (reloadForUpdate()) e.preventDefault()
})
